<template>
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingBar',
  props: {
    message: {
      type: String,
      default: 'Loading...'
    }
  }
}
</script>